import React from 'react';
import classNames from 'classnames';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import PropTypes from 'prop-types';
import { FDBox, FDPrimaryActionButton } from '@facet-wealth/design';
import fr from 'facet-rest';
import { navigateToPage } from 'Views/Page/Content/Templates';
import useUserContext from 'Context/UserContext';
import { useSnackbarContext } from 'Context/SnackbarContext';
import Sentry from 'Integrations/Sentry';

const useStyles = buildUseStyles('CompleteAccountRetitlingButton', (() => ({
  root: {},
})));

const CompleteAccountRetitlingButton = ({
  className,
  completed,
  resource,
}) => {
  const classes = useStyles();
  const { isAgent } = useUserContext();
  const { displayErrorMessage } = useSnackbarContext();

  const handleAccountRetitlingWizardClick = async () => {
    if (completed) {
      return;
    }

    resource.withRelationship(
      fr.relationships.accountRetitlingWizard.name,
      async (rel) => {
        try {
          const [accountRetitlingStep] = await rel.link('related').get();
          navigateToPage(accountRetitlingStep.link('self').url(), isAgent);
        } catch (err) {
          Sentry.createSentryErrorLog(err);
          displayErrorMessage('Error navigating to account retitling');
        }
      },
      () => {},
    );
  };

  const actionPrompt = resource.withRelationship(fr.relationships.accountRetitlingWizard.name, (rel) => rel.meta('prompt'), () => 'Complete Retitling');

  const label = completed ? 'Completed' : actionPrompt;

  return (
    <FDBox
      className={classNames(classes.root, className)}
    >
      <FDPrimaryActionButton
        test={'complete-account-retitling-button'}
        label={label}
        size={'sm'}
        onClick={handleAccountRetitlingWizardClick}
      />
    </FDBox>
  );
};

CompleteAccountRetitlingButton.defaultProps = {
  className: '',
  completed: false,
};

CompleteAccountRetitlingButton.propTypes = {
  className: PropTypes.string,
  completed: PropTypes.bool,
  resource: PropTypes.object.isRequired,
};

export default CompleteAccountRetitlingButton;
